/** ແປຂໍ້ຄວາມຜິດພາດ/ລະບົບເປັນພາສາລາວງ່າຍ — ຫຼີກຄຳອັງກິດໃນ UI cashier */
export function formatPosUserErrorMessage(raw: string): string {
  const s = raw.trim();
  if (!s) return "ເກີດຂໍ້ຜິດພາດ — ລອງອີກຄັ້ງ";

  const lower = s.toLowerCase();

  if (lower.includes("provision") || lower.includes("sellable")) {
    return "ບໍ່ສາມາດເພີ່ມສິນຄ້ານີ້ໄດ້ — ກວດຫມວດສິນຄ້າ ຫຼື ຕິດຕໍ່ຜູ້ຄຸມຮ້ານ";
  }
  if (lower.includes("fitment") || lower.includes("eligibility")) {
    return "ສິນຄ້ານີ້ຍັງບໍ່ພ້ອມຂາຍ — ຕິດຕໍ່ຜູ້ຄຸມຮ້ານ";
  }
  if (lower.includes("idempotency") || lower.includes("idempotent")) {
    return "ຄຳຮ້ອງຊ້ຳ — ລະບົບສະແດງຜົນເດີມ";
  }
  if (lower.includes("shift") && lower.includes("clock")) {
    return "ຕ້ອງເປີດກະກ່ອນຂາຍ";
  }
  if (lower.includes("pos.sell") || lower.includes("permission")) {
    return "ບໍ່ມີສິດຂາຍ — ຕິດຕໍ່ຜູ້ຄຸມຮ້ານ";
  }
  if (lower.includes("stock") || lower.includes("quantity")) {
    return "ສະຕ໋ອກບໍ່ພໍ";
  }
  if (lower.includes("barcode") || lower.includes("not found")) {
    return "ບໍ່ພົບລະຫັດນີ້ໃນຮ້ານ";
  }
  if (lower.includes("exchange rate") || lower.includes("rate map")) {
    return "ຍັງບໍ່ມີອັດຕາແລກ — ຕິດຕໍ່ຜູ້ຄຸມຮ້ານໃຫ້ຕັ້ງຄ່າຮ້ານ";
  }
  if (lower.includes("settlement")) {
    return "ຍັງບໍ່ສາມາດຊຳລະໄດ້ — ຕິດຕໍ່ຜູ້ຄຸມຮ້ານ";
  }

  return s;
}

export function posToastError(raw: unknown): string {
  if (raw instanceof Error) return formatPosUserErrorMessage(raw.message);
  if (typeof raw === "string") return formatPosUserErrorMessage(raw);
  return "ເກີດຂໍ້ຜິດພາດ — ລອງອີກຄັ້ງ";
}
